<template>
    <Table>
        <TableBody>
            <TableBodyRow
                v-for="service in services"
                :key="service.id.value"
            >
                <TableBodyRowCell>
                    <CheckboxInput
                        :label="service.title"
                        :name="requestInputName"
                        :checked="isServiceSelectedCallback(service.id)"
                        :value="service.id.value"
                        :disabled="disabled"
                    />
                </TableBodyRowCell>
                <TableBodyRowCell>
                    {{ service.durationInMinutes }} mins
                </TableBodyRowCell>
            </TableBodyRow>
        </TableBody>
    </Table>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import ServiceID from '@/App/Service/Entity/ServiceID'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'

    const props = defineProps({
        services: {
            type: Object as PropType<Service[]>,
            required: true,
        },
        isServiceSelectedCallback: {
            type: Function as PropType<(serviceId: ServiceID) => boolean>,
            required: true,
        },
        requestInputName: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })
</script>
